import css from 'styled-jsx/css'
import { colors } from 'theme'
import fonts, { fontSizes } from 'theme/fonts'

export default css`
  .table-body {
    min-height: 200px;
    position: relative;
  }

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${colors.alpha(colors.white, 0.4)};
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const tableHeader = css`
  .table-header-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${colors.frame};
    height: 60px;
    background-color: ${colors.white};
    border: 1px solid ${colors.border};
  }

  .table-header-field {
    padding: 0 10px;
    font: ${fonts.bold};
  }
`

export const tableItem = css`
  .table-item-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 50px;
    background-color: ${colors.white};
    border: 1px solid ${colors.border};
    border-top: none;
    cursor: pointer;
  }

  .table-item-container:hover {
    background-color: ${colors.lightGray};
  }

  .table-item-field {
    padding: 0 10px;
    text-align: left;
    font: ${fonts.regular};
    font-size: ${fontSizes.small};
  }
`
